import React, { forwardRef, useMemo, useEffect, useCallback, useImperativeHandle, Profiler, useRef } from 'react';
import { useEventEmitter, useOverlayToggle, useEmitterListener, USE_RETRIEVE_DATA_EVENTS, allActions, SENTRY_EVENTS, SENTRY_GLOBAL_COMPONENT, defaultQueryFn } from '@ace/react-utilities';
import LoadingHandler, { LoadingWrapper } from 'Components/LoadingWrapper';
import { formatDashboardRetrievalUrl, DashboardComponentName, useDashboardQuery } from 'Components/Dashboard/DashboardHelper';
import DashboardHeader from 'Components/Dashboard/DashboardHeader';
import DashboardFooter from 'Components/Dashboard/DashboardFooter';
import MessageCenter from 'Components/MessageCenter';
import TabCenter from 'Components/TabCenter';
import HelpOverlay from 'Components/HelpOverlay';
import track from 'react-tracking';
import { formatTrackingData } from 'tracking/useUTag';
import onRenderCallback from 'tracking/onRenderCallback';
import executeTealium from 'tracking/executeTealium';
import { useDispatch } from 'react-redux';
import * as Sentry from "@sentry/react";
import { SMARTGoalOverlayContextProvider, useSMARTGoalDisplayOverlay } from 'context/SMARTGoalOverlayContext';

export default function Dashboard(props) {
    const applyEmitterHandler = useEventEmitter(DashboardComponentName);
    const dispatch = useDispatch();

    const retrievalUrl = useMemo(() => {
        return formatDashboardRetrievalUrl(props.variantID);
    }, [props.variantID]);

    useEffect(() => {
        dispatch(allActions.dashboardVariantActions.setDashboardVariant(props.variantID));
    }, [dispatch, props.variantID]);

    useEffect(() => {
        applyEmitterHandler((emitter) => {
            emitter.once(USE_RETRIEVE_DATA_EVENTS.ON_FETCH_SUCCESS, (data) => {
                executeTealium(data.TealiumData);
            });
        });
    }, [applyEmitterHandler]);

    useEmitterListener(DashboardComponentName, USE_RETRIEVE_DATA_EVENTS.ON_FETCH_SUCCESS, (data) => {
        //set user
        dispatch(allActions.userActions.setUserData(data.User));

        Sentry.setUser({ id: data.User.CustNmbr });

        //set dashboard tabs
        dispatch(allActions.dashboardTabActions.setDashboardTabs(data.TabCenter));
    });

    useEmitterListener(SENTRY_GLOBAL_COMPONENT, SENTRY_EVENTS.ON_SENTRY_ERROR, (err) => {
        Sentry.captureException(err);
    });

    useEmitterListener(SENTRY_GLOBAL_COMPONENT, SENTRY_EVENTS.ON_SENTRY_MESSAGE, (msg) => {
        Sentry.captureMessage(msg);
    });

    useEmitterListener(SENTRY_GLOBAL_COMPONENT, SENTRY_EVENTS.ON_SENTRY_EVENT, (event) => {
        Sentry.captureEvent(event);
    });

    //const { error, isLoading, data } = useDashboardQuery();

    return (
        <>
        
            {/* <SMARTGoalsWrapper ref={goalsOverlayRef} /> */}
            {/* <LoadingWrapper error={error} isLoaded={!isLoading} data={data}>
                {(data) => (<TrackedDashboard data={data} />)}
            </LoadingWrapper> */}
            {useMemo(() => {
                return (
                    <LoadingHandler retrievalUrl={retrievalUrl} componentName={DashboardComponentName}>
                        {(data) => {
                            if (data?.SMARTGoalsEnabled || false) {
                                return (
                                    <SMARTGoalOverlayContextProvider>
                                        <TrackedDashboard data={data} />
                                    </SMARTGoalOverlayContextProvider>
                                );
                            } else {
                                return  (
                                    <TrackedDashboard data={data} />
                                );
                            }
                        }}
                    </LoadingHandler>
                );
            }, [retrievalUrl])}
        </>
    );
}

function DashboardContent({data}) {
    const classes = useSMARTGoalDisplayOverlay();

    return (
        <Profiler id="DashboardContent" onRender={onRenderCallback}>
            <div id={DashboardComponentName} className={classes}>
                <div className="app" >
                    
                        {useMemo(() => (<DashboardHeader content={data.DashboardHeader} />), [data.DashboardHeader])}

                        {useMemo(() => (<MessageCenter retrievalUrl={data.MessageCenter.RetrievalUrl} type={data.MessageCenter.Type} componentName={data.MessageCenter.Type} />), [data.MessageCenter.Type, data.MessageCenter.RetrievalUrl])}

                        {useMemo(() => (<TabCenter content={data.TabCenter} />), [data.TabCenter])}

                        <HelpOverlay />

                        {useMemo(() => (<DashboardFooter />), [])}
                </div>
            </div>
        </Profiler>
    );
}

const TrackedDashboard = track(({ data }) => formatTrackingData({ dashboard: data.DashboardHeader.DashboardTitle, component: DashboardComponentName, viewComponent: DashboardComponentName } ))(DashboardContent);